module.exports = __webpack_public_path__ + "assets/img/other_monitor1.872190fe.png";